import { Portal, Root } from "@radix-ui/react-dialog";
import { Overlay, Props } from "./Modal.Parts";

export const Modal = ({ children, onOpenChange, open, modal }: Props) => (
  <Root open={open} onOpenChange={onOpenChange} modal={modal}>
    <Portal>
      <Overlay />
      {children}
    </Portal>
  </Root>
);
